module.exports = __webpack_public_path__ + "media/images/products/products/modal/4-85e179095eab5418fc109733f065268e.jpg";